export default __webpack_public_path__ + "a05a7fbf0764b20757d65ffea8651252.png";